import axios from "@/services/mediligo-axios";

const neoparentUsers = {
  sendInvite: data => axios.post(`/api/user/invite/`, data),
  addUser: data => axios.post(`/api/user`, data),
  getNotificationsForUser: () => axios.get(`/api/user/notifications`),
  setNotificationRead: id => axios.get(`/api/user/notifications/${id}/read`),
  editUserSettings: (id, data) =>
    axios.put(`/api/user/settings`, data),
  editUserLanguage: lang => axios.put(`/api/user/language/${lang}`),
  editDeeplLanguage: lang => axios.put(`/api/user/translation/${lang}`),
  grantAccessToOther: data => axios.put(`/api/user/access`, data),
  updateUserData: data => axios.put(`/api/user`, data),
  selectPatient: patientId => axios.put(`/api/user/patient/select/${patientId}`),
  getLatestActivityForPatientAndUser: (patientId, type, userId) => axios.get(`/api/patient/latestActivity/${patientId}?type=${type}&userId=${userId}`),
  getLatestActivityForPatientAndHospital: (patientId, type) => axios.get(`/api/patient/latestActivity/${patientId}?type=${type}`)
};

const neoparentNurses = {
  getAllNurses: () => axios.get(`/api/nurse/all`),
  getAllArchivedNurses: () => axios.get(`/api/nurse/all/archived`),
  getNurse: id => axios.get(`/api/nurse/${id}`),
  editNurse: (id, data) => axios.put(`/api/nurse/${id}`, data),
  deleteNurse: id => axios.delete(`/api/nurse/${id}`),
  reactivateNurse: nurse => axios.put(`/api/nurse/reactivate/${nurse.id}`, nurse),
};

const neoparentPatients = {
  getPatient: id => axios.get(`/api/patient/${id}`),
  getPatientVisit: id => axios.get(`/api/patient/${id}/visit`),
  getPatientParents: id => axios.get(`/api/patient/${id}/parents`),
  getPatientOthers: id => axios.get(`/api/patient/${id}/others`),
  getAllPatientsForHospital: id => axios.get(`/api/patient/all/${id}`),
  getExportForAllData: id => axios.get(`/api/patient/${id}/export/all`), // TODO - Missing in backend
  getExportForPostData: (lang, id) => axios.get(`/api/export/posts/${lang}/${id}`, {responseType: "blob"}),
  toggleArchivePatient: (id, data) =>
    axios.put(`/api/patient/${id}/archive`, data),
  setPatientDeceased: id => axios.put(`/api/patient/${id}/deceased`),
  addPatient: data => axios.post(`/api/patient`, data),
  editPatient: (id, data) => axios.put(`/api/patient/${id}`, data),
  getLatestBioDataEntryForPatient: id =>
    axios.get(`/api/biodataentry/latest/${id}`),
  getAllBioDataEntriesForPatient: id =>
    axios.get(`/api/biodataentry/all/${id}`),
  addBioDataEntry: (id, data) => axios.post(`/api/biodataentry/${id}`, data),
  editBioDataEntry: (id, type, value) =>
    axios.put(`/api/biodataentry/${id}/${type}`, {[type]: value}),
  deleteBioDataEntry: (id, type) =>
    axios.delete(`/api/biodataentry/${id}/${type}`),
  editPatientLanguages: (id, languages) =>
    axios.put(`/api/patient/${id}/language/${languages}`),
  readmitPatient: (id) =>
    axios.put(`/api/patient/${id}/readmit`)
};

const neoparentPosts = {
  getAllPostsForPatient: id => axios.get(`/api/post/all/${id}`),
  getPostsForPatientPage: (id, skip = 0, take = 15) => axios.get(`/api/post/all/${id}/paged?skip=${skip}&take=${take}`),
  getAllForHospital: (startDate, endDate) => axios.get(`/api/post/all-hospital?startDate=${startDate}&endDate=${endDate}`),
  addPost: (patientId, data) => axios.post(`/api/post/${patientId}`, data),
  editPost: (postId, data) => axios.put(`/api/post/${postId}`, data),
  deletePost: (id, data = null) => axios.delete(`/api/post/${id}`, data ? { data } : undefined),
  likePost: id => axios.put(`/api/post/like/${id}`),
  postRead: id => axios.put(`/api/post/mark-as-read/${id}`),
  translatePost: id => axios.get(`/api/post/translate/${id}`),
  addCommentToPost: (id, data) =>
    axios.post(`/api/post/${id}/comment/add`, data),
  editComment: (postId, commentId, data) =>
    axios.put(`/api/post/${postId}/comment/update/${commentId}`, data),
  deleteCommentFromPost: id => axios.delete(`/api/post/comment/${id}`),
  getMilestones: patientId => axios.get(`/api/milestone?id=${patientId}`),
  translateMilestoneTitles: patientId => axios.get(`/api/milestone/translate?id=${patientId}`),
  addMilestone: data => axios.post(`/api/milestone`, data),
  addChecklist: (postId, data) => axios.put(`/api/post/${postId}/checklist`, data),
  removeDeceased: (patientId) => axios.delete(`/api/post/last-for-patient/${patientId}`),
};

const neoparentReflections = {
  getAllForPatient: id => axios.get(`/api/reflection/all/${id}`),
  getReflection: id => axios.get(`/api/reflection/${id}`),
  create: (patientId, data) => axios.post(`/api/reflection/${patientId}`, data),
  update: (reflectionId, data) => axios.put(`/api/reflection/${reflectionId}`, data),
  delete: id => axios.delete(`/api/reflection/${id}`),
  translate: id => axios.get(`/api/reflection/translate/${id}`)
};

const neoparentVisits = {
  getLatestVisitForPatient: id => axios.get(`/api/visit/${id}`),
  addVisit: data => axios.post(`/api/visit`, data),
  editVisit: (id, data) => axios.put(`/api/visit/${id}`, data),
  deleteVisit: id => axios.delete(`/api/visit/${id}`),
  confirmVisit: (id, data) => axios.put(`/api/visit/confirm/${id}`, data),
  markCommentRead: (id) => axios.put(`/api/visit/comment/read/${id}`),
  getAllForUser: () => axios.get(`/api/visit/user/all`),
  translate: (id) => axios.get(`/api/visit/translation/${id}`),
  translateComment: (id)  => axios.get(`/api/visit/translationComment/${id}`)
};

const neoparentUploads = {
  getFile: (id) => axios.get(`/api/upload/${id}`),
  uploadFile: (data) => axios.post(`/api/upload`, data),
  getAllForPatient: id => axios.get(`/api/upload/all/${id}`),
  deleteImage: (uploadId) =>
    axios.delete(`/api/upload/${uploadId}`)
};

const neoparentFeedback = {
  sendBugReport: data => axios.post(`/api/feedback/bug`, data),
  sendFeedback: data => axios.post(`/api/feedback`, data)
};

const neoparentHospital = {
  getHospitalInfo: () => axios.get("/api/hospital/"),
  editHospitalInfo: data => axios.put("/api/hospital/", data),
  editHospitalMessages: data => axios.put("/api/hospital/messages", data)
};

const neoparentDictionaryEntries = {
  getAll: (query = "", nonSensitive = false, useUserTranslation = true) =>
    axios.get(
      `/api/dictionaryentry/all?search=${encodeURIComponent(query)}&nonSensitive=${nonSensitive}&useUserTranslation=${useUserTranslation}`
    ),
  getAllForPatient: (id, useUserTranslation = true) =>
    axios.get(`/api/dictionaryentry/${id}?useUserTranslation=${useUserTranslation}`),
  getDeceasedDictionaryEntry: () => axios.get(`/api/dictionaryentry/deceased`),
  addEntry: data => axios.post(`/api/dictionaryentry`, data),
  editEntry: (id, data) => axios.put(`/api/dictionaryentry/${id}`, data),
  deleteEntry: id => axios.delete(`/api/dictionaryentry/${id}`),
  removeTagFromEntry: (id, tagId) => axios.delete(`/api/dictionaryentry/${id}/removeTag/${tagId}`),
};

const neoparentCategories = {
  getCategories: () => axios.get("/api/category/all"),
  getCategoriesWithEntries: () => axios.get("/api/category/all/entries"),
  addCategory: data => axios.post(`/api/category`, data),
  editCategory: (id, data) => axios.put(`/api/category/${id}`, data),
  deleteCategory: id => axios.delete(`/api/category/${id}`)
};

const neoparentTags = {
  getTags: () => axios.get("/api/tag"),
  addTag: data => axios.post(`/api/tag`, data),
  editTag: (id, data) => axios.put(`/api/tag/${id}`, data),
  deleteTag: id => axios.delete(`/api/tag/${id}`)
};

const neoparentShadowDictionary = {
  getLanguages: () => axios.get(`/api/shadow-dictionary/languages`),
  getByLanguage: (languageCode) => axios.get(`/api/shadow-dictionary?languageCode=${languageCode}`),
  updateManual: (id, data) => axios.put(`/api/shadow-dictionary/${id}`, data),
  resetToAuto: (id) => axios.post(`/api/shadow-dictionary/${id}/reset`),
};

const neoparentShadowTags = {
  getLanguages: () => axios.get(`/api/shadow-tags/languages`),
  getByLanguage: (languageCode) => axios.get(`/api/shadow-tags?languageCode=${languageCode}`),
  updateManual: (id, data) => axios.put(`/api/shadow-tags/${id}`, data),
  resetToAuto: (id) => axios.post(`/api/shadow-tags/${id}/reset`),
};

const neoparentActivities = {
  addActivity: (data) => axios.post(`/api/activity`, data),
  toggleActivity: (id) => axios.put(`/api/activity/toggle/${id}`),
  deleteActivity: (id) => axios.delete(`/api/activity/${id}`)
}

const neoparentDownloads = {
  getDownloadHistory: (patientId, userId) => axios.get(`/api/export/history/list/${patientId}/${userId}`),
}

const curaeConsent  = {
  getUserConsent: (userId) => axios.get(`/api/consent/status/user/${userId}`),
  ssoCuraeConsent: () => axios.get('/api/curaeConsent/sso'),
}

const hospitalHistory  = {
  getDismissalHistoryList: (startDate, endDate) => axios.get(`/api/HospitalHistory/dismissal?startDate=${startDate}&endDate=${endDate}`),
  getPageHistory: (startDate, endDate) => axios.get(`/api/HospitalHistory/pages?startDate=${startDate}&endDate=${endDate}`),
}

const userInvites  = {
  //note: patientID should be in the model or query parameter, nog in the url !
  addInvite: (patientId, data) => axios.put(`/api/userInvite/${patientId}/add`, data),
  refresh: (id) => axios.patch(`/api/userInvite/${id}`),
  refreshParent: (id) => axios.patch(`/api/userInvite/parent/${id}`),
  getListForPatient: (patientId) => axios.get(`/api/UserInvite/list/${patientId}`),
  getList: () => axios.get(`/api/UserInvite/list`),
}

const neoparentAuth = {
  requestMagicLink: (email) => axios.post('/api/auth/magic-link/request', { email }),
  checkCodeChannels: (email) => axios.post('/api/auth/code/channels', { email }),
  requestEmailCode: (email) => axios.post('/api/auth/code/request/email', { email }),
  requestSmsCode: (email) => axios.post('/api/auth/code/request/sms', { email }),
  requestWhatsappCode: (email) => axios.post('/api/auth/code/request/whatsapp', { email }),
  verifyCode: (email, code) => axios.post('/api/auth/code/verify', { email, code }),
 }

const neoparentAiTags = {
  suggest: (text, languageCode = null, maxSuggestions = 5) =>
    axios.post(`/api/aitag/suggest`, { text, languageCode, maxSuggestions }),
};


export {
  neoparentUsers,
  neoparentNurses,
  neoparentPatients,
  neoparentPosts,
  neoparentReflections,
  neoparentVisits,
  neoparentUploads,
  neoparentDictionaryEntries,
  neoparentFeedback,
  neoparentHospital,
  neoparentCategories,
  neoparentTags,
  neoparentActivities,
  neoparentDownloads,
  curaeConsent,
  hospitalHistory,
  userInvites,
  neoparentAuth,
  neoparentShadowDictionary,
  neoparentShadowTags,
  neoparentAiTags
};
